module.exports = __webpack_public_path__ + "media/images/front/hospitals_search/icon/article-9b44b38d4264d56fd0763d9c64a642c1.svg";